export const API = {
	auth: {
		login: `/user/login`,
		check2FA: `/user/check2FA`,
		requestReset: `/user/request-reset-password`,
		resetPassword: `/user/reset-password`,
	},
	users: {
		profile: `/user/profile`,
		create: `/user/register/`,
		edit: `/user/`,
		delete: `/user/`,
		list: `/user`,
	},
	alerts: {
		create: `/alert`,
		edit: `/alert/`,
		delete: `/alert/`,
		list: `/alert`,
	},
	external: {
		busStops: "/external/mobiliario",
		createIncidence: "/external/incidence",
		pendingIncidences: "/external/pending-incidences",
		acceptPendingIncidence: (id) => `/external/pending-incidences/${id}/accept`,
		cleaningTasks: "/external/cleaning-tasks",
		incidenciasHistorial: "/external/incidencias-historial",
		ordenesTrabajo: "/external/ordenes-trabajo",
		postOrdenTrabajo: "/external/ordenes-trabajo",
	},
};
